
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const FireExtinguisherSalesPage = () => {
  const products = [
    { type: 'Kuru Kimyevi Tozlu', sizes: '1-12 kg', usage: 'A-B-C sınıfı yangınlar' },
    { type: 'Köpüklü', sizes: '2-50 litre', usage: 'A-B sınıfı yangınlar' },
    { type: 'Karbondioksitli (CO₂)', sizes: '2-45 kg', usage: 'B-C sınıfı yangınlar' },
    { type: 'Su Bazlı', sizes: '6-9 litre', usage: 'A sınıfı yangınlar' },
  ];

  const faqs = [
    {
      question: 'Hangi yangın tüpünü seçmeliyim?',
      answer: 'Kullanım alanına göre yangın tüpü seçimi yapılmalıdır. Ofisler için ABC tozlu, mutfaklar için köpüklü veya CO₂, elektrik panoları için CO₂ tüpler önerilir.',
    },
    {
      question: 'Yangın tüpü fiyatları nedir?',
      answer: 'Fiyatlar tüp tipi, boyutu ve markasına göre değişiklik gösterir. Detaylı fiyat teklifi için bizimle iletişime geçebilirsiniz.',
    },
    {
      question: 'Yangın tüpü satışında garanti var mı?',
      answer: 'Evet, sattığımız tüm yangın tüpleri üretici garantisi ile birlikte gelir ve periyodik bakım hizmetimizden faydalanabilirsiniz.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              Yangın Tüpü Satış
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Her türlü yangın söndürme tüpü satışı ve profesyonel danışmanlık hizmeti
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="font-display font-bold text-3xl text-dark-900 mb-6">
              Profesyonel Yangın Söndürme Tüpü Satışı
            </h2>
            <p className="text-dark-600 leading-relaxed mb-6">
              İpek Yangın Söndürme olarak, ev, işyeri, fabrika, restoran ve tüm ticari alanlar için <strong>yangın söndürme tüpü satış</strong> hizmeti sunuyoruz. Yangın güvenliği konusunda uzman ekibimiz, ihtiyacınıza en uygun yangın tüpü seçiminde size yardımcı olur.
            </p>
            <p className="text-dark-600 leading-relaxed mb-6">
              Yangın tüpü satış hizmetimiz kapsamında, kuru kimyevi tozlu, köpüklü, karbondioksitli (CO₂) ve su bazlı yangın söndürme tüpleri bulunmaktadır. Tüm ürünlerimiz TSE standartlarına uygun ve sertifikalıdır.
            </p>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4 mt-12">
              Yangın Tüpü Çeşitleri
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
              {products.map((product, index) => (
                <div key={index} className="bg-dark-50 rounded-lg p-6 border-2 border-dark-100">
                  <h4 className="font-display font-semibold text-xl text-dark-900 mb-3">
                    {product.type}
                  </h4>
                  <div className="space-y-2 text-dark-600">
                    <p><strong>Boyutlar:</strong> {product.sizes}</p>
                    <p><strong>Kullanım Alanı:</strong> {product.usage}</p>
                  </div>
                </div>
              ))}
            </div>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Kimler İçin Uygun?
            </h3>
            <ul className="list-disc list-inside space-y-2 text-dark-600 mb-8">
              <li>Ofisler ve iş merkezleri</li>
              <li>Restoranlar, kafeler ve oteller</li>
              <li>Fabrikalar ve üretim tesisleri</li>
              <li>Depolar ve lojistik merkezler</li>
              <li>Apartman ve site yönetimleri</li>
              <li>Bireysel kullanıcılar (ev, araç)</li>
            </ul>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Hizmet Sürecimiz
            </h3>
            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  1
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-1">İhtiyaç Analizi</h4>
                  <p className="text-dark-600">Kullanım alanınızı değerlendirip en uygun yangın tüpü tipini belirliyoruz.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  2
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-1">Teklif Sunumu</h4>
                  <p className="text-dark-600">Şeffaf fiyatlandırma ile detaylı teklif sunuyoruz.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  3
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-1">Teslimat ve Kurulum</h4>
                  <p className="text-dark-600">Yangın tüplerini teslim edip doğru konumlandırma konusunda bilgilendirme yapıyoruz.</p>
                </div>
              </div>
            </div>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Servis Bölgelerimiz
            </h3>
            <p className="text-dark-600 leading-relaxed mb-8">
              [Şehir] ve çevre ilçelerde yangın tüpü satış hizmeti vermekteyiz. Detaylı bilgi için bizimle iletişime geçebilirsiniz.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-dark-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-dark-900 mb-12 text-center">
            Sık Sorulan Sorular
          </h2>
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-md">
                <h3 className="font-display font-semibold text-xl text-dark-900 mb-3">
                  {faq.question}
                </h3>
                <p className="text-dark-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-6">
            Yangın Tüpü Satın Almak İster misiniz?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Size en uygun yangın tüpünü seçmek için hemen bizimle iletişime geçin
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/iletisim" 
              className="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-50 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Teklif Al
            </Link>
            <a 
              href="https://wa.me/905XXXXXXXXX" 
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="bg-green-500 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-600 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-whatsapp-line"></i>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FireExtinguisherSalesPage;
